<script>
import Layout from "@layouts/form";
import Usuario from "@forms/Usuario";

export default {
  page: {
    title: "Detalhes | Usuário"
  },
  components: { Layout, Usuario },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Usuário",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Usuário",
          href: "/Usuario"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <Usuario :editable="editable"></Usuario>
    </div>
  </Layout>
</template>
